import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Unity Development",
      desc: "5+ years of experience developing 2D, 3D, XR, Mobile and more in Unity.",
      icon: "fas fa-gamepad",
    },
    {
      name: "HMTL5 | Angular | React",
      desc: "Professional experience with full-stack development for landing pages and interactive playable experiences.",
      icon: "fas fa-desktop",
    },
    {
      name: "Game Design",
      desc: "Over 7 years of prototyping and designing systems for games both analog and digital: always tested and optimized.",
      icon: "fas fa-pencil-ruler",
    },
    {
      name: "Performance Optimization",
      desc: "Over 3 years of improving GPU and CPU to ensure the projects I work on are compatabile on any device a client might use.",
      icon: "fas fa-dice",
    },
    {
      name: "XR Development",
      desc: "Experience developing for AR/VR/MR platforms including Oculus, Hololens, and WebXR.",
      icon: "fas fa-vr-cardboard",
    },
    {
      name: "Educational Content",
      desc: "Work with clients like FableVision and OurEnglish to create educational games and interactive experiences for target audiences.",
      icon: "fa-solid fa-apple-whole",
    },
    // {
    //   name: "SEO Marketing",
    //   desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
    //   icon: "fas fa-chart-simple",
    // },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do
            <span 
                className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"
                style={{ width: 150}}
            /></p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
